module.exports = __webpack_public_path__ + "public/images/computer.cde26987249e54740d5c54409a64fc25.svg";